export default __webpack_public_path__ + "static/media/Ellipse13.67e53fa9.png";